import React, { FC, useEffect, useState, useRef } from "react";
import { ReactComponent as ActionMenuIcon } from "images/ActionMenuIcon.svg";
import styles from "./Menu.module.sass";
import { ReactComponent as PrintIcon } from "images/PrintIcon.svg";
import { ReactComponent as DownloadIcon } from "images/DownloadBlackIcon.svg";
import { ReactComponent as UploadIcon } from "images/DownloadGreenIcon.svg";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "toolkit/hooks";
import { dowloadDocument, printDocument, uploadDocument } from "toolkit/steps/stepTwo/stepTwo.thunks";

export const Menu: FC = () => {
	const [menuVisibility, setMenuVisibility] = useState(false);
	const { organizationId } = useParams();
	const dispatch = useAppDispatch();
	const inputRef = useRef<HTMLInputElement | null>(null);
	const uploadType = useRef<string>("");

	const menuVisibilityHandler = (e: React.MouseEvent) => {
		e.stopPropagation();
		setMenuVisibility(!menuVisibility);
	};

	const hideMenu = () => {
		setMenuVisibility(false);
	};

	useEffect(() => {
		document.addEventListener("click", hideMenu);

		return () => {
			document.removeEventListener("click", hideMenu);
		};
	}, []);

	const printHandler = () => {
		dispatch(printDocument({ orgId: Number(organizationId) }));
		hideMenu();
	};

	const downloadHandler = () => {
		dispatch(dowloadDocument({ orgId: Number(organizationId) }));
		hideMenu();
	};

	const uploadHandler = (files: FileList | null) => {
		switch (uploadType.current) {
			case "version":
				dispatch(uploadDocument({ orgId: Number(organizationId), file: files![0] }));
				break;
			default:
				break;
		}
		if (inputRef.current) {
			inputRef.current.value = "";
		}
	};

	const openExplorer = (type: string) => {
		inputRef.current?.click();
		uploadType.current = type;
		hideMenu();
	};

	return (
		<>
			<div onClick={menuVisibilityHandler} className={styles["menu-btn"]}>
				<ActionMenuIcon className={styles["menu-btn-icon"]} />
				{menuVisibility && (
					<div onClick={(e) => e.stopPropagation()} className={styles.menu}>
						<button onClick={printHandler} className={styles["menu-item"]}>
							<div className={styles["icon-wrp"]}>
								<PrintIcon />
							</div>
							<span>Печать</span>
						</button>
						<button onClick={downloadHandler} className={styles["menu-item"]}>
							<div className={styles["icon-wrp"]}>
								<DownloadIcon />
							</div>
							<span>Скачать документ</span>
						</button>
						<button onClick={() => openExplorer("version")} className={styles["menu-item"]}>
							<div className={styles["icon-wrp"]}>
								<UploadIcon />
							</div>
							<span>Загрузить утверждённую версию</span>
						</button>
						{/* <button onClick={() => openExplorer("registry")} className={styles["menu-item"]}>
							<div className={styles["icon-wrp"]}>
								<UploadV2Icon />
							</div>
							<span>Загрузить файл ресстра бизнес-процессов</span>
						</button> */}
					</div>
				)}
			</div>
			<input
				ref={inputRef}
				onChange={(e) => uploadHandler(e.target.files)}
				type="file"
				id={`uploadDoc`}
				className="none"
				accept=".docx, .pdf"
			/>
		</>
	);
};
